import { metrics, TheWestSection } from '@news-mono/component-library'
import { ArticleV4DTO } from '@west-australian-newspapers/publication-types'
import { layout } from '../../../App.routing'

export const getAmpArticleComposition = (
    article: ArticleV4DTO,
    section: TheWestSection,
) =>
    layout.composition({
        type: 'box',
        props: {
            containerWidth: metrics.thewest.siteMetrics.mainContentWidth,
            horizontalGutters: 'unset',
            verticalGutters: ['unset', 'unset'],
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'amp-sticky-ad-unit',
                    props: {
                        slot: {
                            id: 'amp-article-sticky-footer',
                            size: 'leaderboard',
                            pageType: 'article',
                        },
                    },
                }),
                layout.component({
                    type: 'article',
                    props: {
                        meta: {
                            slug: article.slug,
                            kind: 'article',
                            inlinePublicationContent: [
                                {
                                    kind: 'ad',
                                    insertAfter: 3,
                                    content: [
                                        {
                                            noticePosition: 'below-center',
                                            hiddenUntilLoaded: true,
                                            slot: {
                                                id: 'amp-article-mrec-one',
                                                size: 'mobileMrec',
                                                pageType: 'article',
                                            },
                                        },
                                    ],
                                },
                                {
                                    kind: 'sport-call-to-action',
                                    insertAfter: 6,
                                },
                                {
                                    kind: 'inline-taboola-amp',
                                    insertAfter: 6,
                                },
                            ],
                        },
                        dataDefinitionArgs: {
                            publicationId: article.id,
                        },
                        section,
                    },
                }),
                layout.component({
                    feature: 'taboola',
                    type: 'taboola',
                    props: {
                        taboolaContainerId: 'taboola-below-article-thumbnails',
                        locationType: 'article',
                    },
                }),
            ],
        },
    })
